function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4258 21.6513L10.2876 21.3749H9.97855H3.017C1.62942 21.3749 0.5 20.2455 0.5 18.8582V3.767C0.5 2.37944 1.62944 1.25 3.017 1.25H24.9832C26.3705 1.25 27.5 2.37942 27.5 3.767V18.8582C27.5 20.2455 26.3705 21.3752 24.9832 21.3752H18.0217H17.7127L17.5745 21.6515L15.2688 26.2624L15.2688 26.2624C14.9215 26.9569 14.4403 27.25 14 27.25C13.5597 27.25 13.0785 26.9569 12.7312 26.2624L10.4258 21.6513Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 12.25,
  r: 1.75,
  fill: "#0D53FC"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.75,
  cy: 12.25,
  r: 1.75,
  fill: "#0D53FC"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.25,
  cy: 12.25,
  r: 1.75,
  fill: "#0D53FC"
});

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.be5b9267.svg";
export { ForwardRef as ReactComponent };